import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { eliminarContratacion } from '../../../actions/colaboradores';

const EliminarContratacion = ({ contratacion, reestablecerContratacion }) => {

    const dispatch =  useDispatch();

    const [eliminarData, setEliminarData] = useState({
        id: null, 
        id_colaborador: null
    });

    const [eliminarModal, setEliminarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    /* Eliminar contratacion */
    const handleProcesar = async () => {
        await setStatusProcesar(true);
        await dispatch(eliminarContratacion(eliminarData));
        await handleCerrar();
        await setStatusProcesar(false);
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            reestablecerContratacion(null);
            setEliminarModal(false);
        }
    }

    useEffect(() => {
        if(contratacion){
            setEliminarModal(true);

            setEliminarData({
                ...eliminarData, 
                id: contratacion.id, 
                id_colaborador: contratacion.id_colaborador
            });
        }
    }, [contratacion]);

    return (
        <Modal show={eliminarModal} backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Eliminar contratación</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>¿Deseas eliminar la contratación del {contratacion?.inicio ? new Date(contratacion?.inicio).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Sin definir'}?</p>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-danger mr-3" onClick={() => handleCerrar()} disabled={ statusProcesar }><i className="fas fa-times fa-sm"></i> No</button>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Si</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Si</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default EliminarContratacion;